export var SDK_VERSION = '6.2.0';
//# sourceMappingURL=version.js.map